var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { style: _vm.boxStyle }, [
        _c("div", { staticClass: "mobile-page custom-nav-container" }, [
          _c(
            "div",
            { staticClass: "nav-tabs" },
            _vm._l(_vm.configObj.tabList.list, function (tab, tIndex) {
              return _c(
                "div",
                {
                  key: tIndex,
                  staticClass: "tab-item",
                  class: { active: _vm.activeTab === tIndex },
                  style: _vm.getTabStyle(tIndex),
                  on: {
                    click: function ($event) {
                      return _vm.switchTab(tIndex)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(tab.value) + " ")]
              )
            }),
            0
          ),
          _vm.isMany
            ? _c(
                "div",
                { staticClass: "nav-grid", style: _vm.gridStyle },
                _vm._l(_vm.showList, function (item, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.status !== false,
                          expression: "item.status !== false",
                        },
                      ],
                      key: index,
                      staticClass: "nav-item",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "icon-box", style: _vm.iconBoxStyle },
                        [
                          item.img
                            ? _c("img", { attrs: { src: item.img, alt: "" } })
                            : _c("div", { staticClass: "empty-box" }, [
                                _c("span", {
                                  staticClass: "iconfont-diy iconfont icon-tu",
                                }),
                              ]),
                        ]
                      ),
                      _c(
                        "p",
                        { staticClass: "nav-label", style: _vm.labelStyle },
                        [_vm._v(_vm._s(item.info[0] ? item.info[0].value : ""))]
                      ),
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "nav-one" }, [
                _c(
                  "div",
                  { staticClass: "menu-scroll" },
                  _vm._l(_vm.showList, function (item, index) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.status !== false,
                            expression: "item.status !== false",
                          },
                        ],
                        key: index,
                        staticClass: "nav-item",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "icon-box", style: _vm.iconBoxStyle },
                          [
                            item.img
                              ? _c("img", { attrs: { src: item.img, alt: "" } })
                              : _c("div", { staticClass: "empty-box" }, [
                                  _c("span", {
                                    staticClass:
                                      "iconfont-diy iconfont icon-tu",
                                  }),
                                ]),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "nav-label", style: _vm.labelStyle },
                          [
                            _vm._v(
                              _vm._s(item.info[0] ? item.info[0].value : "")
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }